import SjLine from 'images/sj/header-line.png'
import SjLogo from 'images/sj/header-logo.png'
import React from 'react'
import styled from 'styled-components'

/**
 * SJ用グローバルヘッダー・全ての画面に適用するヘッダー
 */
const SjGlobalHeader: React.FC = () => {
  return (
    <SjArea>
      <SjLogoArea>
        <SjLogoImg src={SjLogo} />
      </SjLogoArea>
      <SjLineArea>
        <SjLineImg src={SjLine} />
      </SjLineArea>
    </SjArea>
  )
}

const SjArea = styled.div`
  background: var(--color-text-for-main-background);
  width: 100%;
  height: 44px;
`

const SjLogoArea = styled.div`
  width: 128px;
  height: 35px;
`

const SjLogoImg = styled.img`
  width: 128px;
  height: 35px;
`

const SjLineArea = styled.div`
  width: 100%;
  height: 9px;
`

const SjLineImg = styled.img`
  width: 100%;
  height: 9px;
  vertical-align: top;
`

export default SjGlobalHeader
